import React, { Component } from "react";
import { Nav, NavItem } from "react-bootstrap";
import axios from "axios";
import _ from "underscore";
import LoaderPanel from "../components/LoaderPanel";
import TitlePage from "../components/TitlePage";
import withLoadSave from "../components/LoadSave";
import MenuNavbar from "../components/MenuNavbar";
import { EDTableSection, EDTabs, EDTable, EDTableRow } from "../components/EDDOM";
import moment from "moment";

class TransactionalLog extends Component {
  switchView = url => {
    this.props.history.push(url);
  }

  createClicked = () => {
    this.props.history.push("/transactional/templates/new"); 
  }

  deleteConfirmClicked = async id => {
    await axios.delete('/api/transactional/templates/' + id);
    await this.props.reload();
  }

  duplicateClicked = async id => {
    await axios.post('/api/transactional/templates/' + id + '/duplicate');
    await this.props.reload();
  }

  render() {
    let minWidth = '600px';
    let maxWidth = '1024px';

    var haserror = false;
    this.props.data.forEach(d => {
      if (d.error) {
        haserror = true;
      }
    });

    return (
      <MenuNavbar {...this.props}>
        <TitlePage title="Transactional Log"
          tabs={
            <EDTabs>
              <Nav className="nav-tabs space15" activeKey="3">
                <NavItem eventKey="1" onClick={this.switchView.bind(null, '/transactional')}>Dashboard</NavItem>
                <NavItem eventKey="2" onClick={this.switchView.bind(null, '/transactional/templates')}>Templates</NavItem>
                <NavItem eventKey="3" disabled>Log</NavItem>
              </Nav>
            </EDTabs>
          }
        />
        <LoaderPanel isLoading={this.props.isLoading}>
          <EDTableSection>
          {
            this.props.data.length ?
              <EDTable className="growing-margin-left" minWidth={minWidth} maxWidth={maxWidth}>
                <thead>
                  <tr>
                    <th>Subject</th>
                    <th>Tag</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Date</th>
                    {
                      haserror &&
                        <th>Error</th>
                    }
                  </tr>
                </thead>
                  {
                  _.map(this.props.data, (l, index) =>
                      <EDTableRow key={l.id} index={index}>
                        <td>
                          <ul className="list-inline">
                            <li>
                              <h4 className="name-padded">
                                {l.subject}
                              </h4>
                            </li>
                          </ul>
                        </td>
                        <td>
                          {l.tag || 'untagged'}
                        </td>
                        <td>
                          {l.fromname + ' <' + l.fromemail + '>'}
                        </td>
                        <td>
                          {l.toname ? l.toname + ' <' + l.to + '>' : l.to}
                        </td>
                        <td>
                          {moment(l.ts).format('l LTS')}
                        </td>
                        {
                          haserror &&
                          <td className="text-danger">
                            {l.error}
                          </td>
                        }
                      </EDTableRow>
                  )
                }
              </EDTable>
              :
              <div className="text-center space-top-sm">
                <h4>No transactional messages found!</h4>
                <h5>When you send them, your most recent transactional messages will appear here.</h5>
              </div>
          }
          </EDTableSection>
        </LoaderPanel>
      </MenuNavbar>
    );
  }
}

export default withLoadSave({
  extend: TransactionalLog,
  initial: [],
  get: async () => (await axios.get('/api/transactional/log')).data,
});



// WEBPACK FOOTER //
// ./src/containers/TransactionalLog.js